import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import { DialogActions, DialogContent, DialogContentText } from '@mui/material';
import Button from '@mui/material/Button';
import React from 'react';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { VersionableId } from '../../../../types/versionableId';

type Props = {
  readonly isOpen: boolean;
  readonly esmeId?: VersionableId;
  readonly onConfirmClick: () => void;
  readonly onCancelClick: () => void;
};

const EsmeDeleteDialog = (props: Props) => {
  const {
    isOpen,
    esmeId,
    onConfirmClick,
    onCancelClick,
  } = props;

  return (
    <Dialog
      open={isOpen}
      onClose={onCancelClick}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">
        Delete ESME
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          Are you sure you want to delete ESME with <strong>{esmeId?.resourceName}</strong> id?
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancelClick} color='inherit'>Cancel</Button>
        <Button startIcon={<DeleteForeverIcon />} color='primary' onClick={onConfirmClick}>
          Delete ESME
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EsmeDeleteDialog;
